export default __webpack_public_path__ + "static/media/1857.42933273.png";